import DTODBA21 from "@/service/DTODBA21";
import DTODBA09 from "@/service/DTODBA09";

const state = {
  token: window.sessionStorage
    ? window.sessionStorage.getItem("userToken")
    : false,
  joinedTeams: null
};

const actions = {
  setLoginUserInfo({ commit }, obj) {
    commit("setToken", obj);
  },
  getLoginUserInfo({ commit, state }) {
    // 處理登入邏輯.
    return new Promise((resolve, rejects) => {
      const defaultAction = "join";
      if (state.token) {
        this._vm.$cathayAxios
          .post(DTODBA21.getLoginUserInfo, {
            /*token: state.token*/
          })
          .then(resp => {
            if (resp.returnCode === 0) {
              if (resp.data === defaultAction || resp.data === "login") {
                commit("setToken", false);
              }
              resolve(resp.data);
            } else {
              commit("setToken", false);
              resolve(defaultAction);
            }
          });
      } else {
        resolve(defaultAction);
      }
    });
  },
  async getAllTeam(context) {
    if (context.state.joinedTeams != null) {
      return context.state.joinedTeams;
    }
    const cathayTeamAry = [];
    //集團
    const resp_cathayall = await $cathayAxios.post(DTODBA09.queryByCondition, {
      team_code: "TM_20220610161704354h7D",
      is_effective: "Y"
    });
    if (resp_cathayall.returnCode === 0 && resp_cathayall.data) {
      cathayTeamAry.push(resp_cathayall.data);
    }
    //國泰
    const resp_cathaylife = await $cathayAxios.post(DTODBA09.queryByCondition, {
      team_code: "TM_20220610163125701qHu",
      is_effective: "Y"
    });
    if (resp_cathaylife.returnCode === 0 && resp_cathaylife.data) {
      cathayTeamAry.push(resp_cathaylife.data);
    }

    context.commit("setJoinedTeams", cathayTeamAry);
  },
  async getIsEmp({ commit, dispatch }) {
    const teams = await dispatch("getAllTeam");
    return teams
      ? teams.filter(team => team.team_code == "TM_20220610161704354h7D")
          .length > 0
      : false;
  },
  //預留未來國壽員工用
  async getIsCathayGroup({ commit, dispatch }) {
    const teams = await dispatch("getAllTeam");
    return teams
      ? teams.filter(team => team.team_code == "TM_20220610163125701qHu")
          .length > 0
      : false;
  }
};

const mutations = {
  setToken(state, obj) {
    if (window.sessionStorage) {
      window.sessionStorage.setItem("userToken", obj);
    }
    state.token = obj;
  },
  setJoinedTeams(state, teams) {
    state.joinedTeams = teams;
  }
};

export default {
  state,
  actions,
  mutations
};
